import React from "react";
import WebcamCapture from "../../Util/web-camera";
import { useLocation } from "react-router-dom";
import { useJobCompletion } from "../../../JobCompletionContext";

const WebcamCaptureLandscaping = (props) => {
  const { state } = useLocation();
  const { updateCache } = useJobCompletion();

  console.log("state", state);

  return (
    <WebcamCapture
      address={state.addressLong}
      driver={state.driver}
      script_id={state.script_id}
      image_upload_path={`${state.image_upload_path.replace(
        "${service}",
        state.service
      )}`}
      type={state.service}
      updateCache={() => updateCache(state.service)}
      close={() => window.history.back()}
      service={state.service}
    />
  );
};

export default WebcamCaptureLandscaping;
